import React, { useContext, useEffect, useState, useMemo } from "react";
import { useReactTable, getCoreRowModel, flexRender } from "@tanstack/react-table";
import { FilterContext } from "../../context/Filter";
import { fetchlastPurchahedPVIN } from "./PvinKip";

const PurchasedQuantityPvin = () => {
  const [lastPurchasedData, setLastPurchasedData] = useState([]);
  const { superArn, childArn } = useContext(FilterContext);

  const urlParams = new URLSearchParams(window.location.search);
  const vinFromUrl = urlParams.get("vin");
  // console.log(vinFromUrl, "urrll")
  const finalArn = vinFromUrl || childArn || superArn;

  const payload1 = finalArn ? { arn: finalArn } : null;

  const fetchLastPurchasedPvinData = async () => {
    try {
      const response = await fetchlastPurchahedPVIN(payload1);

      const formattedData =
        response?.map((item) => ({
          dealerName: item.key[0] || "-",
          ppl: item.key[1] || "-",
          pl: item.key[2] || "-",
          count: item.doc_count || 0,
        })) || [];

      setLastPurchasedData(formattedData);
    } catch (error) {
      console.error("Error fetching PVIN data:", error);
    }
  };

  useEffect(() => {
    if (finalArn) {
      fetchLastPurchasedPvinData();
    }
  }, [finalArn]);

  // Define columns for TanStack Table
  const columns = useMemo(
    () => [
      {
        header: "Dealer Name",
        accessorKey: "dealerName",
      },
      {
        header: "PPL",
        accessorKey: "ppl",
      },
      {
        header: "PL",
        accessorKey: "pl",
      },
      {
        header: "Count",
        accessorKey: "count",
      },
    ],
    []
  );

  const table = useReactTable({
    data: lastPurchasedData,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <div className="p-2">
      <div className="overflow-x-auto">
        <table className="min-w-full border border-gray-300 rounded-lg text-sm">
          <thead className="bg-[#1467B3] text-white">
            {table.getHeaderGroups().map((headerGroup) => (
              <tr key={headerGroup.id}>
                {headerGroup.headers.map((header) => (
                  <th
                    key={header.id}
                    className="border-b px-4 py-2 text-left font-semibold"
                  >
                    {flexRender(header.column.columnDef.header, header.getContext())}
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          <tbody>
            {table.getRowModel().rows.length > 0 ? (
              table.getRowModel().rows.map((row) => (
                <tr key={row.id} className="hover:bg-gray-50">
                  {row.getVisibleCells().map((cell) => (
                    <td key={cell.id} className="border-b px-4 py-2">
                      {flexRender(cell.column.columnDef.cell, cell.getContext())}
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={columns.length}
                  className="text-center py-4 text-gray-500"
                >
                  No data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PurchasedQuantityPvin;
